import {Box} from 'components/Grid';
import {RecommendationsSlider} from 'components/RecommendationsSlider';
import {Typography} from 'components/Typography';
import React, {FC} from 'react';
import style from './style.module.scss';
import {IProductShort} from 'modules/products/types';
import classNames from 'classnames';
import {SkeletonWrapper} from 'modules/skeleton/components/SkeletonWrapper';
import {PRODUCT_PLACEHOLDER} from 'core/constants';
import {IAnalyticsMeta} from 'core/types';
import {IProductRecommendation} from 'modules/home/models';
import cs from 'classnames';
import {ProductSnippetAnalyticsProvider} from 'modules/analytics/providers/ProductSnippetAnalyticsProvider';

interface IProps {
    className?: string;
    titleClassName?: string;
    data?: IProductRecommendation;
    isLoading?: boolean;
    analytics?: IAnalyticsMeta;
}

const LAZY_ITEMS: IProductShort[] = Array(4)
    .fill(PRODUCT_PLACEHOLDER)
    .map((item, idx) => ({...item, offerId: idx}));

// eslint-disable-next-line @typescript-eslint/naming-convention
export const Recommendations: FC<IProps> = ({className, data, isLoading, analytics, titleClassName}) => {
    if (!data && !isLoading) {
        return null;
    }

    const {items, title} = data ?? {items: [], title: ''};

    const itemsOrPlaceholders = isLoading ? LAZY_ITEMS : items;

    if (!itemsOrPlaceholders?.length) {
        return null;
    }

    return (
        <SkeletonWrapper className={classNames(style.main, className)} disabled={!isLoading}>
            <Box className={classNames(style.boxContainer)}>
                <Typography
                    data-skeleton-item={true}
                    className={cs(style.sliderTitle, titleClassName)}
                    element={'div'}
                    variant={'title-20-m'}
                >
                    {isLoading ? 'placeholder' : title}
                </Typography>
                <div className={style.container}>
                    <ProductSnippetAnalyticsProvider>
                        <RecommendationsSlider list={itemsOrPlaceholders} analytics={analytics} />
                    </ProductSnippetAnalyticsProvider>
                </div>
            </Box>
        </SkeletonWrapper>
    );
};
